import { inject } from '@angular/core';

import { LibModulesWolcModule } from '../../../components/lib-modules-wolc.module';
import { BooktechAppService } from "../../../services/booktech-app.service";


import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Injectable, Inject, Injector } from '@angular/core';

import { DynformControl } from '../../../model/dymform-control';
import { CountryDialCodeUtil, CountryDialCode } from '../../../model/country-dial-codes';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
//  

import { ContentChange } from 'ngx-quill'
import { debounceTime } from 'rxjs/operators'

import {BehaviorSubject, Observable} from 'rxjs';

import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';

import { MiscUtil } from '../../../util/misc.util';

// import { autocomplete } from '../../../services/ui.service';
import { BtAlertComponent } from '../../ui/bt-alert/bt-alert.component';
import { TelephoneValueAccessorDirective } from '../../../directives/telephone-value-accessor.directive';


// import {
//     TextAreaEmoji }from "@windmillcode/quill-emoji";

@Component({
    selector: 'bt-dynamic-form-control',
    imports: [
        LibModulesWolcModule,
        BtAlertComponent,
        TelephoneValueAccessorDirective
    ],
    templateUrl: './bt-dynamic-form-control.component.html',
    styleUrls: ['./bt-dynamic-form-control.component.scss']
})
export class BtDynamicFormControlComponent implements OnInit {
  bas = inject(BooktechAppService);
  elementRef = inject(ElementRef);

  @Input() control!: DynformControl;
  @Input() form!: UntypedFormGroup;
  @Input() options:any = { };

  @Output() change = new EventEmitter<any>();
  @Output() event = new EventEmitter<any>();
  @Output() click = new EventEmitter<any>();

  data:any = {

  }

  // @ViewChild('quillEditor', {
  //   static: true
  // }) quillEditor: QuillEditorComponent|null = null;

  Infinity = Infinity;

  isFocused = false;
  jsonParseError = false;

  onInputNumberFocus(): void {
    this.isFocused = true;
    // Update the displayed text directly, because nz-input-number's signal may not re-render during typing.
    this.setInputNumberDisplayValue();
    this.refreshInputNumberDisplay();
  }

  onInputNumberBlur(): void {
    this.isFocused = false;
    // Defer so nz-input-number is done with its own fixValue, then rewrite the displayed text directly.
    setTimeout(() => {
      this.setInputNumberDisplayValue();
      this.refreshInputNumberDisplay();
    }, 0);
  }

  private refreshInputNumberDisplay(): void {
    const fc = this.control?.fc as UntypedFormControl | null;
    if (fc && fc.setValue) {
      // Trigger writeValue so nz-input-number re-runs the formatter with the current focus state
      fc.setValue(fc.value, { emitEvent: false, emitViewToModelChange: false });
    }
  }

  private setInputNumberDisplayValue(): void {
    const input = this.elementRef.nativeElement.querySelector('input.ant-input-number-input') as HTMLInputElement | null;
    const fc = this.control?.fc as UntypedFormControl | null;
    if (!input || !fc || fc.value === undefined || fc.value === null) return;
    const formatted = this.numberFormatter(fc.value);
    if (input.value !== formatted) {
      input.value = formatted;
    }
  }

  quillModules:any = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, false] }],

      ['bold', 'italic', 'underline'], // , 'strike'       // toggled buttons
      // ['blockquote', 'code-block'],
  
      // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      // [{ 'direction': 'rtl' }],                         // text direction
  
      // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      
  
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      // [{ 'font': [] }],
      // [{ 'align': [] }],
  
      // [ 'emoji' ], // TODO: https://github.com/KillerCodeMonkey/ngx-quill-example/blob/master/src/app/emoji/emoji.component.ts
      ['link' ],
      ['clean'],                                         // remove formatting button
  
      // ['link', 'image', 'video']                         // link and image, video
        //TODO: https://github.com/benwinding/quill-html-edit-button
    ]
  };

  // upload:any = {
  //   fileList: [],
  // }
  
  autocompleteTerm = new BehaviorSubject<string>('');

  constructor() {

  }

  ngOnInit() {
    // Initialize date-picker-multiple from form control value
    if (this.control?.controlType === 'date-picker-multiple') {
      const value = this.control.fc?.value;
      if (value && typeof value === 'string') {
        this.datePickerMultipleSelected = value
          .split(',')
          .map(s => s.trim())
          .filter(s => s.length > 0)
          .map(s => this.bas.ui.dateParse(s))
          .filter(d => d !== undefined) as Date[];
      }
    }
    // console.log("control: ", this.control);

    // if (this.control.controlType == "select") {
      // if(this.bas.envtest) console.log("control: ", this.control, "; options: ", this.control.options());
    // } 

    if (this.control) {
      if (this.control.controlType == "slider") {
        this.control.data.sliderInput = this.control.value;
      } else  if (this.control.controlType == "upload") {
        this.control.data.upload = this.control.data.upload || { };
        this.control.data.upload.fileList = this.control.data.upload.fileList || [ ];
        
      // } else  if (this.control.controlType == "upload") {
       
      } else  if (this.control.controlType == "input-autocomplete") {
        this.control.data.autocomplete = this.control.data.autocomplete || { };
        let ac = this.control.data.autocomplete;
        // if (!this.control.data.autocomplete.options ) 
        ac.optionsAll = ac.options || this.control.optionsList || this.control.options() || [];
        ac.options = ac.optionsAll;

        if (ac.type) {

          this.autocompleteTerm.pipe(
            debounceTime(1000)
          ).subscribe(async (term) => {
            ac.term = term;
            // if(this.bas.envtest) console.log("autocomplete.pipe.1000, ac: ", ac);
            if (term == "") {
              ac.options = [];
              return; 
            }

            let json = await this.bas.ws.json({
              aType: "autocomplete",
              action: "autocomplete",
              type: ac.type,
              term: term
            })
            // if(this.bas.envtest) console.log("autocomplete.pipe.1000, json: ", json);
            ac.options = [...json];

          });

          // ac.options2 = this.autocompleteTerm.pipe(
          //   autocomplete(1000, ((term:string) => {
              
          //   if(this.bas.envtest) console.log("autocomplete.pipe.1000, term: " + term);
          //     let json = this.bas.ws.json({
          //       aType: "autocomplete",
          //       action: "autocomplete",
          //       type: ac.type,
          //       term: term
          //     })
          //     if(this.bas.envtest) console.log("autocomplete.pipe.1000, json: ", json);
          //     // ac.options = json;
          //     return json;
          //   }))
          // )
        }

      } else  if (this.control.controlType == "textarea") {
        if (this.control.data.json) {
          // let val =  this.control.value;
          // this.control.data.height = val ? Math.min(val.split(/\r\n|\r|\n/).length * 20, 80) : 80
        }
      }

    }

  }

  onEditorCreated(quill:any) {
    quill.legacyGetSemanticHTML = quill.getSemanticHTML;
    // quill.register('modules/textarea-emoji', TextAreaEmoji, true);

    quill.getSemanticHTML = (a: number, b: number) =>
      quill
        .legacyGetSemanticHTML(a, b)
        .replaceAll(/((?:&nbsp;)*)&nbsp;/g, '$1 ');
  }

  get isValid() { 
    let control:AbstractControl = this.form.controls[this.control.key];

    return control.pristine ||  control.valid; 
  }


  onContentChanged(event:ContentChange) {
    // console.log(MiscUtil.getTimeString() + "onContentChanged: ", event);
  }
  onEditorBlur(event:any) {
    if(this.bas.envtest) console.log(MiscUtil.getTimeString() + ", onEditorBlur: ", event, ", control: ", this.control);
    // console.log("form.value: ", this.control.fc?.value)

    this.emitChange(event, undefined, this.control.fc?.value ); //TODO:target
  }

  onOpenChange(event:any) {
    if(this.bas.envtest) console.log(MiscUtil.getTimeString() + ", onOpenChange: ", event, ", control: ", this.control);
    // this.emitChange("onOpenChange" ); 

    this.onEvent("openChange", { 
      value: event
    });

  }
  onDateRangeChange(idx:number, event:any) {
    if(this.bas.envtest) console.log(MiscUtil.getTimeString() + ", onDateRangeChange, idx: " + idx + ", e: ", event, ", control: ", this.control);
   
    let dates = this.control.fc?.value;
    let sd = dates[0];
    let ed = dates[1];
    if (idx == 0) {

      if (ed && ed.getTime() < sd.getTime()) {
        dates[1] = this.bas.ui.dateAdd(sd, { days: 1 })
      }
    }

  }

  onNumberRangeChange(idx:number, event:any) {
    // console.log("onNumberRangeChange: " + idx + ", e: ", event);
    

    // console.log("control.value: ", this.control.value);
  

    if (this.control.fc) {
      this.control.fc.value[idx] = event.target.value;
      if(this.bas.envtest) console.log("fc.value: ", this.control.fc?.value);
      this.emitChange(event, undefined, this.control.fc.value);//TODO:target
    }
  }

  async onAutocompleteInput(event: any, control:DynformControl) {
    // let value = (event.target as HTMLInputElement).value;
    // if (value) value = value.toLowerCase();
   
    // if(this.bas.envtest) console.log("onAutocompleteInput: ", event);
    let value = typeof event === "string" ? event.toLowerCase() : (event !== undefined ? event : "") + "";
   

    control.data.autocomplete = control.data.autocomplete || { };
    let ac = control.data.autocomplete

    let optionsAll:any[] = (ac.optionsAll || []);
    let item =   (ac.options || []).find((oi:any) => oi.value === event);

    if (ac.type && value != "") {
      if(this.bas.envtest) console.log("onAutocompleteInput, value.next: " + value + ", item: ", item, ", ac: ", ac);
      this.autocompleteTerm.next(value);
      

      
    } else {
      ac.options = value ? optionsAll.filter((opt:any) => {
        let val = opt.value || opt; 
        if (typeof val === "string") val = val.toLowerCase();
        return val.indexOf(value) >= 0;

      }) : optionsAll;

      if(this.bas.envtest) console.log("onAutocompleteInput, value: " + value + "; optionsAll: " + optionsAll.length + "; res: " + ac.options.length);

    }

    // let firstOpt = opts.length ? opts[0] : { };
    // if (typeof firstOpt === "string") {
    //   opts = opts.map((str:string) => { return {   }})
    // }


  


    if (item) {
      // control.data.acSelected = item;
      this.emitChange(item, undefined, event);
    }
  }

  onSliderInputChange(event:any) {
    // console.log("onSliderInputChange, event: ", event);

    this.control.fc!.setValue(event)
  }

  onSliderRangeInputChange(index:number, event:any) {
    let fc = this.control.fc!;
    let value = fc.value;
    if (value === undefined) value = [ this.control.data.min || 0, this.control.data.max || 1000 ];
    // if (value.length >= index) value = [0, 0];
    value[index] = event;
    if(this.bas.envtest) console.log("onSliderInputChange, event: ", event, ", value: ", value);
    
    fc.setValue(value)
  }


  pickerDisabledDate = (date:Date):boolean => {
    if (this.control === undefined) return false;
    // console.log("pickerDisabledDate, date: " + date + ", c: ", this.control);

    let data = this.control.data;
    if (data.disabledDate) {
      return data.disabledDate(date);
    }

    if (data.selectableDates) {
      let dateInt = MiscUtil.getDateAsInt(date);
      if (MiscUtil.binarySearch(data.selectableDates, dateInt) < 0) {

        return true;
      }
    }


    if (data.firstDate !== undefined) {
      let firstDate:Date = data.firstDate;
      // console.log("pickerDisabledDate, date: ", date, ", firstDate: ", firstDate, ", date < firstDate: " + (date.getTime() < firstDate.getTime()));
      if (date.getTime() < firstDate.getTime()) return true;
    }


    return false;
  }
  pickerDisabledDateRangeEnd = (date:Date):boolean => {
    let rangeEndInvalid = this.control.data.rangeEndInvalid;
    if (!rangeEndInvalid) return this.pickerDisabledDate(date);

    let disabled = this.pickerDisabledDate(this.bas.ui.dateAdd(date, { days: -1 }));
    if (disabled) return disabled;

    let sd = this.control.fc?.value[0];
    if (sd === undefined) return disabled;

    if (date.getTime()  < sd.getTime()) return true;

     if (this.control.data.selectableDates) {

        let dates:Date[] = this.bas.ui.getAllDatesBwtweenDates(this.bas.ui.dateAdd(sd, { days: 1 }), date);

        for (let current of dates) {
          let prev = this.bas.ui.dateAdd(current, { days: -1 })
          let dateInt = MiscUtil.getDateAsInt(prev);
          
      
          if (MiscUtil.binarySearch(this.control.data.selectableDates, dateInt) < 0) {
  
            if (date.getTime()  > current.getTime()) {
              return true;
            }
          }
          
        }
      }


    // let current = date;


    // while (current.getTime() > sd.getTime()) {

   
    //   current = this.bas.ui.dateAdd(current, { days: -1 })
    // }

    return disabled;
  }

  onKeyUp(event:any) {
    let ctl = this.control;
    let ct = ctl.controlType;

    if (!ctl.data.triggerChangeOnKeyup) return; 

    let fv =  this.findValue(event);

    if(this.bas.envtest) console.log("onKeyUp, fv: " + fv + ", ev: ", event);


    this.emitChange(event); 
  }

  onChange(event:any, target?:any) {
    if(this.bas.envtest) console.log("onChange.event: ", event);
       
    let ctl = this.control;
    let ct = ctl.controlType;
    let fv =  this.findValue(event, target);
    if (ct == "textarea") {
      if (ctl.data.json) {
        let pretty = this.bas.us.pretty(fv);
        if(this.bas.envtest) console.log("onChange.textarea, fv: " + fv + ", pretty: " + pretty);
        if (fv != pretty) {
          ctl.fc?.setValue(pretty);
        }
        this.jsonParseError = false;
        if (fv && fv !== '') {
          try {
            JSON.parse(fv);
          } catch (e) {
            this.jsonParseError = true;
          }
        }
      } else {
        this.jsonParseError = false;
      }
    }

   
    this.emitChange(event, target); // .target?.value
  }


  onEvent(action:string, data?:any) {

    let c = this.control;

    let event = MiscUtil.extend({ }, { 
      control: c, 
      action: action,
   
    }, data);

    c.onEvent(event);


    this.click.emit(event);
  }

  onClick(event:Event, ctl:any) {
    event.preventDefault();

    let c = this.control;

    c.onClick({ 
      control: c, 
      event: event
    });


    this.click.emit({ 
      control: c, 
      event: event
    });
  }

  isChecked(value: any): boolean {
    const current = this.control.fc?.value;
    return Array.isArray(current) && current.includes(value);
  }

  onCheckboxChange(value: any, checked: boolean) {
    const current: any[] = Array.isArray(this.control.fc?.value) ? [...this.control.fc.value] : [];
    const updated = checked ? [...current, value] : current.filter((v: any) => v !== value);
    this.onCheckboxListChange(updated);
  }

  onCheckboxListChange(event:any) {
    if(this.bas.envtest) console.log("onCheckboxListChange: ", event);
    // console.log("onCheckboxListChange, control.fc: ", this.control);
    
    this.control.fc?.setValue(event);
    this.onModelChange(event);

    if(this.bas.envtest) console.log("onCheckboxListChange, control.fc.value: ", this.control.fc?.value);
    
  }

  onModelChange(event:any, target?:any) {
    if(this.bas.envtest) console.log("onModelChange: ", event, ", target: ", target);
    if (this.control.type === "number" && typeof event === "string" && event.length > 0) {
      
    }
    if (this.control.controlType === "slider") {
      //console.log("onModelChange, event: ", event);
      this.control.data.sliderInput = event;
    }
    else if (this.control.controlType === "slider-range") {
      //console.log("onModelChange, event: ", event);
      this.control.data.sliderInputMin = event[0];
      this.control.data.sliderInputMax = event[1];
    }


   this.emitChange(event, target);
  }

  findValue(event:any, target:any = undefined) {

    let  value = event 
        && typeof event === "object" 
        && event.target
        ? event.target?.value 
        : event;
    

    return value;


  }

  emitChange(event:any, target:any = undefined, value:any = undefined) {
    if (value === undefined) {
      value = this.findValue(event, target);
    }

    if (target == null && event && typeof event === "object" && event.target) target = event.target;

    let c = this.control;

    // console.log("emitChange, key: " + this.control.key 
    //   + ", value: " + c.value + " -> " + value + " | EQ: " +  (c.value === value) )
    if (c.value === value) {
      if(this.bas.envtest) console.log("emitChange: c.value === value", c.value);
      return;
    }

    let pv = c.value;
    c.value = value;

    c.onChange({ 
      control: c, 
      event: event, 
      prevValue: pv, 
      value: value,
      target: target,
    });

    // console.log("key: " + c.key + ", c.updateSourceOnChange: " + c.updateSourceOnChange + ", c.source: " + c.source);
    if (c.updateSourceOnChange && c.source) {
      if(this.bas.envtest) console.log("updateSourceOnChange, key: " + c.key + ", c.valuePath: " + c.valuePath + ", c.value: " + MiscUtil.getOwnNestedProperty(c.source, c.valuePath) + " -> " + c.value);
      MiscUtil.setOwnNestedProperty(c.source, c.valuePath, value);
    }

    this.change.emit({ 
      control: c, 
      event: event,
      value: value
    });
  }

  weekdayCheckChange(val:boolean, wd:number) {
    if (this.control.disabled) return;
    let map = this.control.fc?.value;
    if(this.bas.envtest) console.log("weekdayCheckChange, wd: " + wd + ", val: " + val + ", curr.val: ", map);
    
    if (wd === -1) {
      //all
      for (let i = 1; i <= 7; i++) map[i] = val;
    } else {
      map[wd] = val;

    }
 
    this.control.fc?.setValue(map);

  }
  isAllWeekdays(map:any) {
    if (map === undefined) {
      if(this.bas.envtest) console.log("isAllWeekdays, map == undefined, control: ", this.control );
      if(this.bas.envtest) console.log("isAllWeekdays, map == undefined, control.fc: ", this.control.fc );
      if(this.bas.envtest) console.log("isAllWeekdays, map == undefined, control.fc.value: ", this.control.fc?.value );
      return true;
    }
    for (let i = 1; i <= 7; i++) {
      if (map[i] !== true) return false;
    }
    return true;
  }

  boolMapCheckChange(val:boolean, key:any) {
    let map = this.control.fc?.value;
    if(this.bas.envtest) console.log("boolMapCheckChange, key: " + key + ", val: " + val + ", curr.val: ", map);
    
    if (key === -1) {
      //all
      for (let key of Object.keys(map)) map[key] = val;
    } else {
      map[key] = val;

    }
 
    this.control.fc?.setValue(map);

  }
  isAllBoolMap(map:any) {
    for (let val of Object.values(map)) {
      if (val !== true) return false;
    }
    return true;
  }

  tagsIsAllSelected() {
    let ctrl = this.control;
    let map = this.control.fc?.value || { };
    let opts = ctrl.optionsList || ctrl.options();
    if (Object.keys(map).length === 0) return true;

    // let val = undefined;
    for (let opt of opts) {

      if (map[opt[ctrl.optionsFieldValue]] !== true) return false;
    }
    return true;
  }
  tagsIsSelected(opt:any) {
    let ctrl = this.control;
    let map = ctrl.fc?.value || { };
    return map[opt[ctrl.optionsFieldValue]];
  }
  tagsChange(val:boolean, value:any) {
    let ctrl = this.control;
    let map = ctrl.fc?.value || { };
    let opts = ctrl.optionsList || ctrl.options();
    if (value === -1) {
      for (let opt of opts) {
        map[opt[ctrl.optionsFieldValue]] = val;
      }
    } else {
      if (val) map[value[ctrl.optionsFieldValue]]  = val;
      else delete map[value[ctrl.optionsFieldValue]]; // = val;
    }

    if(this.bas.envtest) console.log("tagsChange, val: " + val + ", value: ", value, ", map: ", map);
    

    this.control.fc?.setValue(MiscUtil.clone(map));

    this.emitChange(map);
  }

  // Er ikke i bruk
  numberPrecisionMode = (value: number | string, precision?: number): number => {
    let num = this.numberParser(value + "");
    //console.log("val: " + value + ", num: " + num + ", precision: " + precision);
    return num;
  }

  numberFormatter = (value: number): string => {
    let data = this.control.data;
    if (value === undefined) return "";
    if (data.numberFormatter === false) return value + "";

    if (data.numberFormatter && typeof data.numberFormatter === "function") return data.numberFormatter(value);

    // While editing, show a plain localized number without forced decimals or thousands separators.
    // Full formatting (fractionSize, thousands separator) is applied on blur.
    if (this.isFocused) {
      let str = value.toString();
      if (data.fractionSize !== undefined && data.fractionSize >= 0) {
        const dotIndex = str.indexOf('.');
        if (dotIndex !== -1) {
          str = str.substring(0, dotIndex + data.fractionSize + 1);
        }
      }
      return str.replace('.', this.bas.ui.DECIMAL_SEPARATOR);
    }

    if (data.suffix) return value + " " + data.suffix;

    if (data.fractionSize) {
      return this.bas.ui.nf(value, Number.isInteger(value) ? 0 : data.fractionSize);
    }
    if (value > 1000)  return this.bas.ui.nf(value, 0);
    return `${value}`;
  }
  numberParser = (value: string): number => {
    let data = this.control.data;
    if (value === undefined) return 0;
    if (data.numberParser && typeof data.numberParser === "function") return parseFloat(data.numberParser(value));

    if (data.suffix) value = value.replace(" " + data.suffix, '');

    return this.bas.ui.nfparse(value, data.fractionSize);
  }


  uploadUrl() {
    // extraParams
    let url = this.bas.ws.getBaseUrlTools() 
      + '?action=uploadDropzone&type='+this.control.data.upload?.type
      +'&uuid=' + this.control.data.upload?.uuid
    ;

    if (this.control.data.upload.extraParams) {
      url += "&" + this.bas.ws.getParamsAsString(this.control.data.upload.extraParams);
    }
    return url;
  }

  uploadHeaders = (file: NzUploadFile): Object => {
    let headers = this.bas.ws.getCommonHeaders();
    //MiscUtil.extend(headers, this.bas.ws.getLoginHeaders());
    return headers;
  }
  handleUploadFile({ file, fileList, event }: NzUploadChangeParam, control:any): void {

    if (this.bas.envtest) console.log('handleUploadFile file: ', file, ", event: ", event);

    const status = file.status;
    const resp = file.response;

    
    let val = fileList.map((file) => file.filename || file.name).join(";");


      
    this.control.fc?.setValue(val);
    this.onModelChange(val);

    if (status !== 'uploading') {
      if (this.bas.envtest) console.log(file, fileList);

      if (status == "removed") {
        let itemId = resp.itemId;

        this.bas.ws.json({ 
          // checkChildApp: true,
          aType: "appService", 
          action: "removeUploadedFile", 
          type: control.data.upload.type,
          itemId: itemId
        
        }).then((json) => {
          if (this.bas.envtest) console.log("removeUploadedFile, json: ", json);
          if (json.success) {
          
          }
        });

      }
    }
    if (status === 'done') {
     
      

      if (this.bas.envtest) console.log(file.name + 'file uploaded successfully, resp: ', resp);

      if (resp.itemId) {
        //TODO
      } else {
        this.bas.ui.error(this.bas.ui.actrans("app.lib.common.error.upload.general" ));
      }


    } else if (status === 'error') {
      if (this.bas.envtest) console.log(`${file.name} file upload failed.`);
      // TODO
      // this.bas.ui.error(this.bas.ui.actrans("common.error.imageUpload", [], false, "En feil oppstod da vi skulle behandle filen du lastet opp. Vanligvis er dette fordi du har lastet opp en JPEG fil i CMYK-format. Kun JPEG bilder i RGB-format kan lastes opp")); //TODO:text
      
    }
  }


  mbscDatepickerInvalid:Date[] = []

  mbscDatepickerOnPageLoading(event:any) {

    let inst = event.inst;
    let fd = event.firstDay;
    let ld = event.lastDay;


    let invalid:any[] = [];
    
    let data = this.control.data;
    if (data.selectableDates) {
        
      let dates:Date[] = this.bas.ui.getAllDatesBwtweenDates(fd, ld);

      for (let current of dates) {
        let dateInt = MiscUtil.getDateAsInt(current);
        
        if (data.selectableDates) {
          if (MiscUtil.binarySearch(data.selectableDates, dateInt) < 0) {
  
            invalid.push(current);
          }
        }
      }
    }


    this.mbscDatepickerInvalid = invalid;
  }

  mbscDatepickerOnChange(event:any) {

  }

  //
  // Date Picker Multiple (custom multi-select date picker using NG-ZORRO)
  //
  datePickerMultipleVisible = false;
  datePickerMultipleSelected: Date[] = [];

  get datePickerMultipleValue(): string {
    if (!this.datePickerMultipleSelected || this.datePickerMultipleSelected.length === 0) {
      return '';
    }
    const fmt = this.control?.data?.format || 'yyyy-MM-dd';
    return this.datePickerMultipleSelected
      .map(d => this.bas.ui.dateFormat(d, fmt))
      .join(', ');
  }

  datePickerMultipleOpen() {
    this.datePickerMultipleVisible = true;
  }

  datePickerMultipleOnOpenChange(open: boolean) {
    this.datePickerMultipleVisible = open;
  }

  datePickerMultipleIsSelected(date: Date): boolean {
    return this.datePickerMultipleSelected.some(d =>
      d.getFullYear() === date.getFullYear() &&
      d.getMonth() === date.getMonth() &&
      d.getDate() === date.getDate()
    );
  }

  datePickerMultipleIsToday(date: Date): boolean {
    const today = new Date();
    return date.getFullYear() === today.getFullYear() &&
           date.getMonth() === today.getMonth() &&
           date.getDate() === today.getDate();
  }

  datePickerMultipleToggleDate(date: Date) {
    const index = this.datePickerMultipleSelected.findIndex(d =>
      d.getFullYear() === date.getFullYear() &&
      d.getMonth() === date.getMonth() &&
      d.getDate() === date.getDate()
    );

    if (index >= 0) {
      // Remove if already selected
      this.datePickerMultipleSelected.splice(index, 1);
    } else {
      // Add to selection
      this.datePickerMultipleSelected.push(new Date(date));
      // Sort by date
      this.datePickerMultipleSelected.sort((a, b) => a.getTime() - b.getTime());
    }

    // Update form control value (comma-separated string)
    const value = this.datePickerMultipleValue;
    this.control?.fc?.setValue(value);
    this.onModelChange(value);
  }

  // Handler for date picker click (prevents default selection behavior)
  datePickerMultipleDateClick(event: any) {
    // The actual toggle is handled by the template click handler
    // This prevents the date picker from closing or setting a value
    return false;
  }

  datePickerMultipleClose() {
    this.datePickerMultipleVisible = false;
  }

  //
  // Telephone (combined prefix + local number)
  //

  // Stabil objekt-referanse for nzDropdownStyle - må IKKE være et inline
  // objektlitteral i malen, siden det ville skapt en ny referanse på hver
  // change-detection-sjekk og gitt NG0100 (ExpressionChangedAfterItHasBeenCheckedError).
  telephonePrefixDropdownStyle = { 'min-width': '240px' };

  /**
   * Returnerer dial code-options for telephone-kontrollen.
   * Bruker control.optionsList hvis satt, ellers bygges fra control.data.counties
   * eller fallback til statisk COUNTRY_DIAL_CODES.
   *
   * Resultatet caches på control.data, siden CountryDialCodeUtil.toOptionsList
   * bygger en ny array (inkl. flagg-emojis for ~230 land) hver gang. Uten cache
   * ville denne getteren returnert en ny array-referanse for hver change-detection-
   * sjekk, noe som gir NG0100 (ExpressionChangedAfterItHasBeenCheckedError) og
   * svært treg rendering siden hele nedtrekkslisten bygges på nytt kontinuerlig.
   */
  get telephonePrefixOptions(): CountryDialCode[] {
    if (this.control?.optionsList?.length) return this.control.optionsList;
    if (!this.control) return [];

    if (!this.control.data.__telephonePrefixOptions) {
      let counties = this.control.data?.counties;
      let preferred = this.control.data?.preferredCountries || ["NO", "SE", "DK", "GB", "DE", "US"];
      let lang = this.bas.ds.findLang() || "no";
      this.control.data.__telephonePrefixOptions = CountryDialCodeUtil.toOptionsList(counties, preferred, lang);
    }

    return this.control.data.__telephonePrefixOptions;
  }


  /**
   * Nåværende prefix (dial code) hentet fra form-control-verdien.
   * F.eks. "+4799887766" -> "+47", "99887766" -> "+47" (default).
   */
  get telephonePrefixValue(): string {
    let val = this.control?.fc?.value;
    let split = CountryDialCodeUtil.splitTelephone(val);
    return split.dialCode;
  }

  /**
   * Lokalt nummer hentet fra form-control-verdien.
   * F.eks. "+4799887766" -> "99887766".
   */
  get telephoneLocal(): string {
    let val = this.control?.fc?.value;
    let split = CountryDialCodeUtil.splitTelephone(val);
    return split.local;
  }

  /**
   * Valideringsstatus for telephone-kontrollen, brukt på nz-input-group
   * sin [nzStatus]-binding for å vise rød ramme ved feil.
   *
   * NG-ZORRO sin egen automatiske deteksjon (via ngControl på det synlige
   * feltet) bør nå fungere siden [formControlName] ligger direkte på
   * inputet (via TelephoneValueAccessorDirective). Denne getteren er en
   * ekstra sikkerhet som garanterer riktig visning selv om nz-input-group
   * sin automatiske statusdeteksjon skulle ha problemer med addOnBefore-
   * kombinasjonen (kjent NG-ZORRO-begrensning for input-grupper).
   */
  get telephoneStatus(): '' | 'error' | 'warning' {
    let fc = this.control?.fc;
    if (!fc) return '';
    return fc.invalid && (fc.dirty || fc.touched) ? 'error' : '';
  }

  /**
   * Kalles når bruker velger ny prefix i nedtreksboksen.
   * Oppdaterer form-control med ny prefix + eksisterende local.
   * Kaller control.data.onPrefixChange callback hvis satt.
   */
  onTelephonePrefixChange(newPrefix: string) {
    let currentLocal = this.telephoneLocal;
    let combined = CountryDialCodeUtil.combineTelephone(newPrefix, currentLocal);
    this.control?.fc?.setValue(combined);

    // Kall onPrefixChange callback (f.eks. for å oppdatere country-feltet)
    if (this.control?.data?.onPrefixChange) {
      this.control.data.onPrefixChange(newPrefix, combined);
    }

    // Standard onChange med sammenslått verdi
    this.emitChange(undefined, undefined, combined);
  }

  // Lokalnummer-input håndteres nå av TelephoneValueAccessorDirective
  // (btTelephoneValueAccessor), som kombinerer prefiks + lokalnummer og
  // skriver hele verdien til FormControl via ControlValueAccessor.

  //
  incrementValue() { this.setValue(true); }
  decrementValue() { this.setValue(false); }
  setValue(inc:boolean) {
    let ctrl = this.control;
    let val = ctrl.fc?.value || 0;

    let newVal = val + (inc ? 1 : -1);

    let min = ctrl.data.min;
    let max = ctrl.data.max;

    if (min !== undefined && newVal < min) return;
    if (max !== undefined && newVal > max) return;


    if (ctrl.fc) {
      ctrl.fc.setValue(newVal);
    }

  }

  onHtmlChange(editHtmlEnabled:boolean) {
    let ctrl = this.control;

      ctrl.controlType = !editHtmlEnabled ? "richtext" : "textarea";

  }

}



